import { createContext, useContext, useEffect, useState } from "react";
import { api, logError } from "@/lib/api";

const FALLBACK = { name: "Pramsia Pvt. Limited", tagline: "Global Ventures", logo_url: "" };
const BrandingContext = createContext(FALLBACK);

export function BrandingProvider({ children }) {
  const [brand, setBrand] = useState(FALLBACK);

  useEffect(() => {
    api
      .get("/branding")
      .then(({ data }) => setBrand({ ...FALLBACK, ...data }))
      .catch((e) => logError("branding", e));
  }, []);

  return <BrandingContext.Provider value={brand}>{children}</BrandingContext.Provider>;
}

export const useBranding = () => useContext(BrandingContext);

export function BrandMark({ className = "h-9 w-9", showText = true, dark = false }) {
  const brand = useBranding();
  const logo = brand.logo_url
    ? brand.logo_url.startsWith("http")
      ? brand.logo_url
      : `${process.env.REACT_APP_BACKEND_URL}${brand.logo_url}`
    : "";

  return (
    <div className="flex items-center gap-3" data-testid="brand-mark">
      {logo ? (
        <img src={logo} alt={brand.name} className={`${className} object-contain`} />
      ) : (
        <div
          className={`${className} flex items-center justify-center rounded bg-primary text-sm font-bold text-primary-foreground`}
        >
          P
        </div>
      )}
      {showText && (
        <div className="leading-tight">
          <div className={`font-display text-sm font-bold ${dark ? "text-white" : ""}`}>
            {brand.name.toUpperCase()}
          </div>
          <div
            className={`text-[10px] uppercase tracking-[0.18em] ${
              dark ? "text-amber-200/80" : "text-muted-foreground"
            }`}
          >
            {brand.tagline}
          </div>
        </div>
      )}
    </div>
  );
}
